module.exports = __webpack_public_path__ + "static/media/KY.54ad9d3f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/KY.svg
// module id = 294
// module chunks = 0